import React from 'react';
import Lottie from 'lottie-react';
import CountUp from 'react-countup';

const Card = ({ title, value,suffix, animationData, onClick }) => {
  const numericValue = parseFloat(value);

  return (
    <div 
      onClick={onClick}
      className="w-full my-2 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center justify-between p-4 cursor-pointer"
      style={{ minHeight: '50px', maxHeight:'60px' }} // Slightly taller than 50px to fit text & animation
    >

<div className="flex-shrink-0">
        {animationData && (
          <Lottie 
            animationData={animationData} 
            style={{ width: 40, height: 40 }} 
          />
        )}
      </div>
      <div className="flex items-center flex-col text-white mr-4">
        <span className="text-sm font-extrabold text-[#e67e22] 00font-medium">{title}</span>
        {value && 
        <span className="text-sm font-semibold">
        <CountUp 
          end={numericValue}
          duration={7}  // 2-second animation, adjust as needed
          separator=","
          suffix={suffix} // use a comma for thousand separators
        />
      </span>}
      </div>
    </div>
  );
};

export default Card;